export default "__VITE_ASSET__0c30a79c__"